import { __assign } from 'tslib';
import * as React from 'react';

/**
 * @description Needlework icon component.
 *
 * @component
 * @example
 * ```jsx
 * import { Needlework } from '@sravni/design-system-icons'
 *
 * <Needlework />
 * ```
 */
var Needlework = React.forwardRef(function (props, ref) { return (React.createElement("svg", __assign({ ref: ref, "data-qa": "Needlework", viewBox: "0 0 20 20", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
    React.createElement("path", { clipRule: "evenodd", d: "M4.987 17.5H3.333a.834.834 0 0 1-.833-.833v-5c0-.46.373-.834.833-.834h1.654c.46 0 .833.374.833.834v5c0 .46-.373.833-.833.833Z", stroke: "currentColor", strokeWidth: "1.5", strokeLinecap: "round", strokeLinejoin: "round" }),
    React.createElement("path", { d: "M10.8 14.167h1.937c.359 0 .708-.117.995-.334l2.006-1.51c.5-.376 1.2-.326 1.643.118v0c.49.493.49 1.292 0 1.785l-1.72 1.727a3.317 3.317 0 0 1-1.697.912l-2.432.488c-.482.097-.98.085-1.457-.035l-2.2-.551a3.27 3.27 0 0 0-.804-.1H5.82", stroke: "currentColor", strokeWidth: "1.5", strokeLinecap: "round", strokeLinejoin: "round" }),
    React.createElement("path", { d: "M10.8 14.167h1.232a1.26 1.26 0 0 0 1.258-1.263v-.252a1.26 1.26 0 0 0-.952-1.224l-1.903-.478a3.887 3.887 0 0 0-.945-.117v0c-.77 0-1.522.229-2.162.658L5.82 12.5", stroke: "currentColor", strokeWidth: "1.5", strokeLinecap: "round", strokeLinejoin: "round" }),
    React.createElement("path", { clipRule: "evenodd", d: "m12.738 3.05-.29.312-.292-.311a1.738 1.738 0 0 0-2.406-.128v0a1.775 1.775 0 0 0-.214 2.453c.85 1.07 1.824 2.127 2.912 2.957 1.114-.851 2.11-1.94 2.974-3.037.562-.713.446-1.747-.239-2.34l-.031-.027a1.741 1.741 0 0 0-2.414.122v0Z", stroke: "currentColor", strokeWidth: "1.5", strokeLinecap: "round", strokeLinejoin: "round" }))); });

export { Needlework };
//# sourceMappingURL=Needlework.js.map
